import React, { Component } from 'react';
import propTypes from 'prop-types';
import debounce from 'lodash.debounce';

import Day from '~/Components/Pages/Calendar/MonthView/Day';

import './Week.scss';

export default class Week extends Component {
  constructor(props) {
    super(props);
    this.state = {
      height: window.innerHeight,
    };
  }

  componentDidMount = () => {
    window.addEventListener('resize', this.setHeight);
  };

  componentWillUnmount = () => {
    window.addEventListener('resize', this.setHeight);
  };

  setHeight = debounce(() => {
    this.setState({ height: window.innerHeight });
  }, 50);

  render() {
    const { days, allDayEvents, weekNumber } = this.props;
    return (
      <div className="week">
        {this.props.week.map((day, key) => {
          if (days[key]) {
            return (
              <Day
                isInPageBreak={(key + 5) % 7 === 0 ? true : false}
                key={key}
                day={day}
                weekNumber={weekNumber}
                time={this.props.time}
                onClick={this.props.onDayClick}
                minDate={this.props.minDate}
                allDayEvents={allDayEvents}
                windowHeight={this.state.height}
              />
            );
          }
        })}
      </div>
    );
  }
}

Week.propTypes = {
  time: propTypes.object,
  onDayClick: propTypes.func,
  minDate: propTypes.object,
  week: propTypes.array,
  days: propTypes.object,
  allDayEvents: propTypes.array,
  weekNumber: propTypes.number.isRequired,
};
